// app/javascript/controllers/clipboard_controller.js
import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["source"]

  copyToClipboard(event) {
    // Prevent form submit + native HTML5 validation firing
    event?.preventDefault()
    event?.stopPropagation()

    const raw =
      this.sourceTarget.value ??
      this.sourceTarget.textContent ??
      ""

    const text = String(raw).trim()

    if (!text) {
      alert("Nothing to copy.")
      return
    }

    // Try modern Clipboard API first (works when iframe allows clipboard-write)
    if (navigator.clipboard?.writeText) {
      navigator.clipboard.writeText(text)
        .then(() => {
          alert("Copied to clipboard!")
        })
        .catch((err) => {
          // Common in iframes on Chrome due to Permissions Policy
          console.warn("Clipboard API blocked/failed, falling back:", err)
          this.manualCopy(text)
        })
      return
    }

    // No Clipboard API available
    this.manualCopy(text)
  }

  manualCopy(text) {
    // Best-effort legacy copy. If it fails, we still give the user the text.
    const ta = document.createElement("textarea")
    ta.value = text
    ta.setAttribute("readonly", "")
    ta.style.position = "fixed"
    ta.style.left = "-9999px"
    ta.style.top = "0"

    document.body.appendChild(ta)
    ta.focus()
    ta.select()

    let ok = false
    try {
      ok = document.execCommand("copy")
    } catch (e) {
      ok = false
    } finally {
      document.body.removeChild(ta)
    }

    if (ok) {
      alert("Copied to clipboard!")
    } else {
      // Last-resort UX that always works
      alert(`Clipboard is blocked in this embedded page.\n\nCopy manually:\n${text}`)
    }
  }
}
